// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041655/js/" + chunkId + "." + {"44":"12b4217e","225":"25a8195b","481":"ea3279a6","486":"7a3c7c52","770":"80b27f71"}[chunkId] + ".0.6680320772891042.chunk.js";
};